import React, { useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as PlayIcon } from "../../assets/Icons/play1.svg";
import { ReactComponent as AddToPlaylistIcon } from "../../assets/Icons/addtoplaylist.svg";
import { ReactComponent as RemoveFromPlaylistIcon } from "../../assets/Icons/removefromplaylist.svg";
import { appInfo, fetchEventDetails } from "../../network/service";
import { updateWatchlistData, updateContinueWatching } from "../../network/service";
import { ToastContainer, toast } from "react-toastify";
import { fetchWatchlistShows } from "../../Screens/MyList/service";
import { getMyListData } from "../../Redux/MyList/MyListSlice";
import { ReactComponent as PremiumIcon } from "../../assets/Icons/premium.svg";
import { imageUrlCheck } from "../../utils/utils";
import { getPodcastModal } from "../../Redux/PodcastModal/podcastModalSlice";
import { getSelectedChannel } from "../../Redux/SelectedChannel/selectedChannelSlice";
import { getSelectedSchedule } from "../../Redux/SelectedScheduleChannel/selectedScheduleChannelSlice";
import { Add } from "@mui/icons-material";
import Util from "./util";
import Translate, { useTranslateText } from "../Multilanguage/Translate";
import { setAiInfo } from "../../Redux/AiType/AiTypeSlice";
import { ReactComponent as Closeicon } from "../../assets/Icons/cross.svg";
import RemoveFromContinueWatchModal from "../Modals/RemoveFromContinueWatchModal";
import ReactDOM from "react-dom";
import YowCard from "./YowCard";
import FlsCard from "./FlsCard";

const GaiaCard = ({ data, metaData, imageUrl, type, thumbnailOrientation, playlist = true, disableHover, showId, categoryName, isChallenge, onRemove, displayedData, activeHoveredId, setActiveHoveredId, rankIndex }) => {
  const handleCardKeyDown = (e, action) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
    }
  };
  const dispatch = useDispatch();
  const translateText = useTranslateText();
  const ai_type = data?.ai_type;
  const {
    showHandleClick,
    replaceImage,
    // afterImageLoad,
    addToWatchlist,
    removeFromWatchlist,
    subscriptionCheck,
  } = Util();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userSubscriptionData = useSelector(
    (state) => state?.userSubscription?.value
  );
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const [watchlistStatus, setWatchlistStatus] = useState();
  const [hovered, setHovered] = useState(false);
  const [imagURL, setImageURL] = useState(
    thumbnailOrientation === "PORTRAIT"
      ? require("../../assets/Images/loading-portrait.gif")
      : require("../../assets/Images/loading-landscape.gif")
  );
  const [isImageLoad, setIsImageLoad] = useState(false);
  const [isRemoveModal, setIsRemoveModal] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [continueWatchingList, setContinueWatchingList] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const pubid = projectInfo?.projectConfig?.pubid || projectInfo?.pubid;
  const isFlsTv = pubid == 50183;
  const isYowTv = pubid == 50187;
  const shouldHideUnhoveredTitle =
    projectInfo?.projectConfig?.pubid === 50152 ||
    (projectInfo?.projectConfig?.config?.HIDE_TITLE_UNDER_MOVIES && windowWidth <= 980);

  useEffect(() => {
    if (data?.watchlist_flag === 1) {
      setWatchlistStatus("added");
    } else {
      setWatchlistStatus("removed");
    }
  }, [data]);

  useEffect(() => {
    setIsImageLoad(true)
    let image;
    if (
      imageUrlCheck(
        thumbnailOrientation === "PORTRAIT"
          ? data?.logo || data?.thumbnail || data?.banner_portrait
          : data?.logo_thumb || data?.thumbnail_350_200
      )
    ) {
      image =
        thumbnailOrientation === "PORTRAIT"
          ? data?.logo || data?.thumbnail || data?.banner_portrait
          : data?.logo_thumb || data?.thumbnail_350_200;
    } else {
      if (data?.type === "SMART_HOME" || data?.type === "GENRE") {
        image = data?.banner ? data?.banner : (thumbnailOrientation === 'PORTRAIT' ? projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE_PORTRAIT : projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE)
      }
      else
        image =
          process.env.REACT_APP_IMAGE_URL +
          (thumbnailOrientation === "PORTRAIT"
            ? data?.logo || data?.thumbnail || data?.banner_portrait
            : data?.logo_thumb || data?.thumbnail_350_200);
    }

    setImageURL(image);
  }, [data, thumbnailOrientation]);

  useEffect(() => {
    if (data?.type === "CONTINUE_WATCHING") {
      setContinueWatchingList(displayedData);
    }
  }, [data]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleCloseRemoveModal = () => {
    setIsRemoveModal(false);
    setHovered(false);
  };
  const handleRemove = (...args) => {
    if (onRemove) onRemove(...args);
    setHovered(false);
  };

  if (isFlsTv) {
    return (
      <FlsCard
        data={data}
        metaData={metaData}
        imageUrl={imageUrl}
        type={type}
        thumbnailOrientation={thumbnailOrientation}
        playlist={playlist}
        showId={showId}
        categoryName={categoryName}
        isChallenge={isChallenge}
        onRemove={onRemove}
        displayedData={displayedData}
        activeHoveredId={activeHoveredId}
        setActiveHoveredId={setActiveHoveredId}
        rankIndex={rankIndex}
      />
    );
  }

  if (isYowTv) {
    return (
      <YowCard
        data={data}
        metaData={metaData}
        imageUrl={imageUrl}
        type={type}
        thumbnailOrientation={thumbnailOrientation}
        playlist={playlist}
        showId={showId}
        categoryName={categoryName}
        isChallenge={isChallenge}
        onRemove={onRemove}
        displayedData={displayedData}
        activeHoveredId={activeHoveredId}
        setActiveHoveredId={setActiveHoveredId}
        rankIndex={rankIndex}
      />
    );
  }

  return (
    <div
      className={`gaiaShowCardContainer ${hovered ? "hovered" : ""} ${isRTL ? "rtl" : ""} ${disableHover ? 'no-hover' : ''} ${data?.type === "SMART_HOME" ? 'genre-card' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title={projectInfo?.projectConfig?.pubid === 50167 ? null : (data?.show_name || data?.video_title || data?.categoryname)}
      onClick={() => {
        dispatch(setAiInfo(ai_type ?? null));
        showHandleClick(
          data,
          type,
          projectInfo,
          thumbnailOrientation,
          getPodcastModal,
          getSelectedChannel,
          getSelectedSchedule,
          ai_type,
          showId,
          categoryName
        );
      }}
      onKeyDown={e => handleCardKeyDown(e, () => {
        dispatch(setAiInfo(ai_type ?? null));
        showHandleClick(
          data,
          type,
          projectInfo,
          thumbnailOrientation,
          getPodcastModal,
          getSelectedChannel,
          getSelectedSchedule,
          ai_type,
          showId,
          categoryName
        );
      })}
      tabIndex={0}
      role="group"
      aria-label={data?.show_name || data?.video_title || data?.categoryname}
    >
      {/* <ToastContainer /> */}

      {isRemoveModal &&
        ReactDOM.createPortal(
          <RemoveFromContinueWatchModal
            setIsRemoving={setIsRemoveModal}
            appInfo={appInfo}
            data={data}
            continueWatchingList={continueWatchingList}
            onRemove={handleRemove}
            onCancel={handleCloseRemoveModal}
          />,
          document.body
        )
      }
      <div className={`imageContainer ${hovered ? "hidden" : ""}`}>
        <img
          className={
            `${!isImageLoad
              ? (thumbnailOrientation === "PORTRAIT" ? "portrait" : "landscape")
              : "showImage"}${data?.challenge_completed && isChallenge ? " blurred-image" : ""}`
          }
          src={imagURL}
          key={data?.show_id}
          onError={(e) => replaceImage(e, thumbnailOrientation, projectInfo)}
          // onLoad={(e) =>
          //   afterImageLoad(
          //     e,
          //     thumbnailOrientation,
          //     data,
          //     setImageURL,
          //     setIsImageLoad,
          //     imageUrlCheck
          //   )
          // }
          onClick={(e) => {
            e.stopPropagation();
            dispatch(setAiInfo(ai_type ?? null));
            showHandleClick(
              data,
              type,
              projectInfo,
              thumbnailOrientation,
              getPodcastModal,
              getSelectedChannel,
              getSelectedSchedule,
              ai_type,
              showId,
              categoryName
            );
          }}
          tabIndex={0}
          role="button"
          aria-label={`Open details for ${data?.show_name || data?.video_title}`}
          onKeyDown={e => handleCardKeyDown(e, () => {
            dispatch(setAiInfo(ai_type ?? null));
            showHandleClick(
              data,
              type,
              projectInfo,
              thumbnailOrientation,
              getPodcastModal,
              getSelectedChannel,
              getSelectedSchedule,
              ai_type,
              showId,
              categoryName
            );
          })}
          alt="ShowImage"
        />
        <div className="premiumStatus">
          {data?.is_free_video === true ? (
            <div className="free">
              <img
                src={require("../../assets/Images/free.png")}
                alt="FreeIcon"
              />
            </div>
          ) : data?.is_locked === true ? (
            <div className="lock">
              <img
                src={require("../../assets/Images/lock.png")}
                alt="LockIcon"
              />
            </div>
          ) : null}
        </div>
        {(data?.type === "CONTINUE_WATCHING" || (data?.watched_percentage > 0 && data?.watched_percentage < 100)) && (
          <div className="continueWatchingBar">
            <div
              className="line"
              style={{
                width:
                  data?.watched_percentage <= 1
                    ? 1 + "%"
                    : data?.watched_percentage + "%",
              }}
            ></div>
          </div>
        )}

        {data?.challenge_completed && isChallenge && (
          <div className="completionIndicator" title={translateText('already_watched')}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13L9 17L20 8" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        )}

        {!shouldHideUnhoveredTitle && (
          <>
            {data?.type === "SMART_HOME" ? (
              <div className="genre-category">
                <h1>{data?.categoryname}</h1>
              </div>
            ) : (
              <h1 className={`cardTitle ${data?.type === "CONTINUE_WATCHING" || (data?.watched_percentage > 0 && data?.watched_percentage < 100) ? "continueWatching" : ""}`}>{projectInfo?.projectConfig?.pubid === 50167 ? null : data?.show_name || data?.video_title}</h1>
            )}
          </>
        )}

        <div className={`hover-content ${(hovered && !disableHover) ? "visible" : ""}`}>
          <img
            className={
              `${!isImageLoad
                ? (thumbnailOrientation === "PORTRAIT" ? "portrait" : "landscape")
                : "showImage"}${data?.challenge_completed && isChallenge ? " blurred-image" : ""}`
            }
            src={imagURL}
            key={data?.show_id}
            onError={(e) => replaceImage(e, thumbnailOrientation, projectInfo)}
            // onLoad={(e) =>
            //   afterImageLoad(
            //     e,
            //     thumbnailOrientation,
            //     data,
            //     setImageURL,
            //     setIsImageLoad,
            //     imageUrlCheck
            //   )
            // }
            onClick={(e) => {
              e.stopPropagation();
              dispatch(setAiInfo(ai_type ?? null));
              showHandleClick(
                data,
                type,
                projectInfo,
                thumbnailOrientation,
                getPodcastModal,
                getSelectedChannel,
                getSelectedSchedule,
                ai_type,
                showId,
                categoryName
              );
            }}
            alt="ShowImage"
          />
          {
            data?.type === "CONTINUE_WATCHING" && (
              <div
                className="close-icon"
                tabIndex={0}
                role="button"
                aria-label="Close"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsRemoveModal(true);
                }}
                style={{ cursor: isRemoving ? "not-allowed" : "pointer", opacity: isRemoving ? 0.5 : 1 }}
                title={<Translate textKey={'remove_from_continue_watching'} />}
              >
                <Closeicon />
              </div>
            )
          }
          {data?.type !== "SMART_HOME" &&
            <div className="premiumStatus">
              {data?.is_free_video === true ? (
                <div className="free">
                  <img
                    src={require("../../assets/Images/free.png")}
                    alt="FreeIcon"
                  />
                </div>
              ) : data?.is_locked === true ? (
                <div className="lock">
                  <img
                    src={require("../../assets/Images/lock.png")}
                    alt="LockIcon"
                  />
                </div>
              ) : null}
            </div>
          }
          {(data?.type === "CONTINUE_WATCHING" || (data?.watched_percentage > 0 && data?.watched_percentage < 100)) && (
            <div className="continueWatchingBar">
              <div
                className="line"
                style={{
                  width:
                    data?.watched_percentage <= 1
                      ? 1 + "%"
                      : data?.watched_percentage + "%",
                }}
              ></div>
            </div>
          )}

          {data?.challenge_completed && isChallenge && (
            <div className="completionIndicator" title={translateText('already_watched')}>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 13L9 17L20 8" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          )}
          {data?.type !== "SMART_HOME" &&
            <div className="extraActions">
              <button
                className="playIconContainer"
                tabIndex={0}
                role="button"
                aria-label={`Play ${data?.show_name || data?.video_title}`}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setAiInfo(ai_type ?? null));
                  showHandleClick(
                    data,
                    type,
                    projectInfo,
                    thumbnailOrientation,
                    getPodcastModal,
                    getSelectedChannel,
                    getSelectedSchedule,
                    ai_type,
                    showId,
                    categoryName
                  );
                }}
                onKeyDown={e => handleCardKeyDown(e, () => {
                  dispatch(setAiInfo(ai_type ?? null));
                  showHandleClick(
                    data,
                    type,
                    projectInfo,
                    thumbnailOrientation,
                    getPodcastModal,
                    getSelectedChannel,
                    getSelectedSchedule,
                    ai_type,
                    showId,
                    categoryName
                  );
                })}
              >
                <PlayIcon />
                <Translate textKey={'watch'} />
              </button>
              {metaData && data?.show_id && playlist && data?.type !== "SMART_HOME" && (
                <>
                  {watchlistStatus === "added" ? (
                    <button
                      className="addToList"
                      tabIndex={0}
                      role="button"
                      aria-label={`Remove ${data?.show_name || data?.video_title} from my list`}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeFromWatchlist(
                          data?.show_id,
                          appInfo,
                          setWatchlistStatus
                        );
                      }}
                      onKeyDown={e => handleCardKeyDown(e, () =>
                        removeFromWatchlist(
                          data?.show_id,
                          appInfo,
                          setWatchlistStatus
                        )
                      )}
                    >
                      <RemoveFromPlaylistIcon />
                    </button>
                  ) : (
                    <button
                      className="addToList"
                      tabIndex={0}
                      role="button"
                      aria-label={`Add ${data?.show_name || data?.video_title} to my list`}
                      onClick={(e) => {
                        e.stopPropagation();
                        addToWatchlist(
                          user,
                          data?.show_id,
                          appInfo,
                          setWatchlistStatus
                        );
                      }}
                      onKeyDown={e => handleCardKeyDown(e, () =>
                        addToWatchlist(
                          user,
                          data?.show_id,
                          appInfo,
                          setWatchlistStatus
                        )
                      )}
                    >
                      <AddToPlaylistIcon />
                    </button>
                  )}
                </>
              )}
            </div>
          }
          {!(projectInfo?.projectConfig?.config?.HIDE_TITLE_UNDER_MOVIES && windowWidth <= 980) && (
            <>
              {data?.type !== "GENRE" &&
                <h1
                  className="title"
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(setAiInfo(ai_type ?? null));
                    showHandleClick(
                      data,
                      type,
                      projectInfo,
                      thumbnailOrientation,
                      getPodcastModal,
                      getSelectedChannel,
                      getSelectedSchedule,
                      ai_type,
                      showId,
                      categoryName
                    );
                  }}
                >
                  {projectInfo?.projectConfig?.pubid === 50167 ? null : data?.show_name || data?.video_title}
                </h1>
              }
              {data?.type !== "GENRE" && (
                <>
                  <div
                    className={`episode ${data?.single_video !== 2 ? "hidden" : ""}`}
                  >
                    {data?.video_title && <span>{data?.video_title}</span>}
                  </div>
                  <div className="duration">
                    {data?.duration_text && (
                      <span className={`duration ${data?.year && "showDot"} ${/^[A-Za-z0-9\s]+$/.test(data?.duration_text) ? "ltr" : ""}`}>
                        {data?.duration_text}
                      </span>
                    )}
                    {data?.rating && (
                      <span className="certificate">{data?.rating}</span>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default GaiaCard;
